export const IconCloseCross: {
  name: 'icon_close_cross-3bd85088e88a'
} = {
  name: 'icon_close_cross-3bd85088e88a'
}
